import React, { useCallback } from 'react';
import classNames from 'classnames';
import { DataRoomSecuritySettings } from 'router/subrouters/DataRoom/models/DataRoom';
import utils from 'utils';
import { ObjectValues } from 'types';

import './FileWatermark.styles.scss';

const WATERMARK_DIRECTION = {
  DIAGONAL: 'diagonal',
  HEADER: 'header',
  FOOTER: 'footer',
} as const;

type WatermarkDirection = ObjectValues<typeof WATERMARK_DIRECTION>;

export type FileWatermarkProps = {
  className?: string;
  fullName: string;
  email: string;
  watermarkSettings: DataRoomSecuritySettings;
  ipAddress?: string;
};

const FileWatermark: React.FC<FileWatermarkProps> = (props) => {
  const { className, fullName, email, ipAddress, watermarkSettings } = props;

  const {
    includeWatermark,
    watermarkDiagonal,
    watermarkHeader,
    watermarkFooter,
    watermarkFullName,
    watermarkEmail,
    watermarkIpAddress,
  } = watermarkSettings;

  const activeDirections = [
    watermarkHeader && WATERMARK_DIRECTION.HEADER,
    watermarkDiagonal && WATERMARK_DIRECTION.DIAGONAL,
    watermarkFooter && WATERMARK_DIRECTION.FOOTER,
  ].filter(Boolean) as WatermarkDirection[];

  const classes = classNames(
    'file-watermark',
    className,
    `count-${activeDirections.length || 0}`,
  );

  const renderWatermark = useCallback(
    (direction: WatermarkDirection) => (
      <div className={classNames('file-watermark__text', direction)}>
        {watermarkEmail && <div>{email}</div>}
        {watermarkFullName && <div>{fullName}</div>}
        {watermarkIpAddress && (
          <>
            <div>{ipAddress}</div>
            <div>{utils.dateFormat(new Date(), 'dd-mm-yy')}</div>
          </>
        )}
      </div>
    ),
    [
      email,
      fullName,
      watermarkEmail,
      watermarkFullName,
      watermarkIpAddress,
      ipAddress,
    ],
  );

  if (!includeWatermark || !activeDirections?.length) return null;

  return <div className={classes}>{activeDirections.map(renderWatermark)}</div>;
};

export default FileWatermark;
